import { Badge } from "@/components/ui/Badge";
import { EM_DASH } from "@/lib/utils";

import { firmwarePcbaFamilyLabel, type FirmwarePcbaFamily } from "./firmwareApi";

const CHIP_CLASS: Record<Exclude<FirmwarePcbaFamily, "fi5a">, string> = {
  "1485": "bg-rose-100 text-rose-800",
  "1509": "bg-teal-100 text-teal-800",
  "1607": "bg-indigo-100 text-indigo-800",
  "1609": "bg-lime-100 text-lime-900",
};

export function FirmwareFamilyChips({ family }: { family: FirmwarePcbaFamily | null }): JSX.Element {
  if (family == null) return <>{EM_DASH}</>;
  const canonical = family === "fi5a" ? "1485" : family;
  return <Badge className={CHIP_CLASS[canonical]}>{firmwarePcbaFamilyLabel(family)}</Badge>;
}
